import { IProject } from "./Project";
import { IViewpoint } from "./Viewpoint";
import { IUser } from "./User";
import { ISurveyLink } from "./SurveyLink";
import { IAdvisorActivity } from "./AdvisorActivity";

export enum TouchpointType {
    DEFAULT = "default",
    MANUAL = "manual",
    AUTO = "auto"
}

export enum TouchpointStatus {
    DRAFT = "draft",
    SCHEDULED = "scheduled",
    ACTIVE = "active",
    COMPLETED = "completed"
}

export interface ISurveyLayout {
    pages: [
        {
            id: string;
            title: string;
            description: string;
            questions: [
                {
                    id: string;
                    title: string;
                    description: string;
                }
            ]
        }
    ];
}


export interface IAlchemerSurveyPage {
    page: number;
    title: string;
    id: string;
    properties: {
        title: string;
        questions: IAlchemerSurveyQuestion[];
    };
}

export interface IAlchemerSurveyQuestion {
    id: string;
    type: string;
    title: string;
    shortname?: string;
    required: boolean;
    properties: {
        question_type: string;
        options?: IAlchemerSurveyOption[];
        [key: string]: any;
    };
}

export interface IAlchemerSurveyOption {
    id: string;
    title: string;
    value: string;
    reporting_value?: string;
}

export interface ITouchpoint {
    id: number;
    uuid: string;
    name: string;
    short_name?: string | null;
    project: IProject;
    type: TouchpointType;
    status: TouchpointStatus;
    created_at: string | null;
    updated_at: string | null;
    scheduled_at?: string | null;
    started_at?: string | null;
    completed_at?: string | null;
    viewpoints?: IViewpoint[];
    created_by: IUser | null;
    analysis_url?: string | null;
    advisor_analysis_url?: string | null;
    product_description?: string | null;
    suppressed_questions?: string[] | null;
    suppressed_sections?: string[] | null;
    product_description_section?: string | null;
    survey_links?: ISurveyLink[] | null;
    default_survey_url?: string | null;
    alchemer_survey_id?: string | null;
    survey_questions_json?: IAlchemerSurveyPage[] | null;
    survey_layout_json?: ISurveyLayout | null;
    advisor_activity?: IAdvisorActivity | null;
    media_analysis_input_questions?: string[] | null;
    media_analysis_highlights?: Array<{ mediaResponseId: number, quote: string }> | null;
    media_analysis_topics?: string[] | null;
    media_analysis_topic_to_media_map?: Record<string, number[]> | null;
    media_analysis_summary?: string | null;
    media_analysis_generated_at?: Date | null;
    media_analysis_version?: string | null;
    highlight_video_url?: string | null;
    highlight_image_url?: string | null;
    advisor_highlight_video_url?: string | null;
    advisor_highlight_image_url?: string | null;
    prompt_html?: string | null;
    prompt_image_url?: string | null;
    prompt_video_url?: string | null;
}
